import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, localizePath, stripLocalePrefix } from '../utils/localePaths';

// Legacy support: old shared/bookmarked links used ?lang=xx on an unprefixed
// URL. Redirect those to the canonical locale-prefixed URL (e.g. /es/pricing)
// instead of just relabeling the same English URL client-side.
const useUrlLanguageDetector = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const langParam = urlParams.get('lang');

    if (langParam && SUPPORTED_LANGUAGES.includes(langParam)) {
      i18n.changeLanguage(langParam);

      const { basePath } = stripLocalePrefix(location.pathname);
      urlParams.delete('lang');
      const search = urlParams.toString();
      navigate(
        `${localizePath(basePath, langParam)}${search ? `?${search}` : ''}${location.hash}`,
        { replace: true }
      );
    }
  }, [location.search, location.pathname, location.hash, i18n, navigate]);
};

export default useUrlLanguageDetector;